 
import { ColumnDef } from "@tanstack/react-table"
import { ArrowUpDown } from "lucide-react"
import {Button} from "../../../components/UiComponents/button"
import {TableStudent, Campus, Semester} from "../../../api/client";
import { formatCampus } from "../../../helpers/stringHelpers";



export const columns: ColumnDef<TableStudent>[] = [
  {
    accessorKey: "usfId",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          abbr={column.getIsSorted() === "asc" ? "Click to sort from algebraically high to low (U99999999 - U00000000)" : "Click to sort from algebraically low to high (U00000000 - U99999999)"}
        >
          U Number
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      )
    },
  },
  {
    accessorKey: "fullName",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          abbr={column.getIsSorted() === "asc" ? `Click to sort from Z - A (descending order)` : `Click to sort from A - Z (ascending order)`}
        >
          Name
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      )
    },
  },
  {
    accessorKey: "netId",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          abbr={column.getIsSorted() === "asc" ? `Click to sort from Z - A (descending order)` : `Click to sort from A - Z (ascending order)`}
        >
          netID
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      )
    },

  },
  {
    accessorKey: "major",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          abbr={column.getIsSorted() === "asc" ? `Click to sort from Z - A (descending order)` : `Click to sort from A - Z (ascending order)`}
        >
          Major
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      )
    },
  },
  {
    accessorKey: "campus",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          abbr={column.getIsSorted() === "asc" ? `Click to sort from Z - A (descending order)` : `Click to sort from A - Z (ascending order)`}
        >
          Campus
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      )
    },
    cell: ({ row }) => {
      const campus = row.original.campus !== undefined 
        ? formatCampus(row.original.campus.toString()) 
        : "Unknown Campus";
      return (
        <div className={"flex "}>{campus}</div>
      )
    }
  },
  {
    accessorKey: "expectedGraduationYear",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          // QUESTION: What even is the sorting logic of this column? Will update abbreviation text when I figure out how this is sorted
          abbr={column.getIsSorted() === "asc" ? "Click to sort in descending order" : "Click to sort in ascending order"}
        >
          Expected Graduation
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      );
    },
    // Custom sorting logic
    sortingFn: (rowA, rowB, columnId) => {
      const semesterOrder = { "Fall": 0.3, "Spring": 0.1, "Summer": 0.2 };
      const semesterA = rowA.original.expectedGraduationSemester !== undefined ? Semester[rowA.original.expectedGraduationSemester] : "Unknown Semester";
      const semesterB = rowB.original.expectedGraduationSemester !== undefined ? Semester[rowB.original.expectedGraduationSemester] : "Unknown Semester";
  
      // First, compare by semester
      const semesterComparison = (semesterOrder[semesterA as keyof typeof semesterOrder] || 0) - (semesterOrder[semesterB as keyof typeof semesterOrder] || 0);
  
      if (semesterComparison !== 0) return semesterComparison;
  
      // If semesters are the same, compare by year
      return (rowA.original.expectedGraduationYear ?? 0) - (rowB.original.expectedGraduationYear ?? 0);
    },
    // Adjust cell rendering as necessary
    cell: ({ row }) => {
      const semesterName = row.original.expectedGraduationSemester !== undefined && row.original.expectedGraduationSemester !== Semester.NotProvided
        ? Semester[row.original.expectedGraduationSemester]
        : "Unknown";

        const gradYear = row.original.expectedGraduationSemester !== undefined && row.original.expectedGraduationSemester !== Semester.NotProvided ? row.original.expectedGraduationYear : ""
      return (
        <div className={"flex "}>{semesterName + " " + gradYear}</div>
      );
    },
  },
  {
    accessorKey: "createdAt",
    header: ({ column }) => {
      return (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
          // Note: sorting logic is not correct here. Will have to be fixed later
          abbr={column.getIsSorted() === "asc" ? "Click to sort in descending order" : "Click to sort in ascending order"}
        >
          Student Created
          <ArrowUpDown className="ml-2 h-4 w-4" />
        </Button>
      )
    },
  },


]
